export const IS_LOGGED_IN = 'IS_LOGGED_IN'
export const SET_TOKEN = 'SET_TOKEN'
export const INVALIDATE_TOKEN = 'INVALIDATE_TOKEN'

export const ASYNC_REQUEST = 'ASYNC_REQUEST'
export const ASYNC_SUCCESS = 'ASYNC_SUCCESS'
export const ASYNC_FAILURE = 'ASYNC_FAILURE'
export const ASYNC_CANCELLED = 'ASYNC_CANCELLED'
export const RECEIVE_EXERCISES = 'RECEIVE_EXERCISES'
export const RECEIVE_TEAMS = 'RECEIVE_TEAMS'
export const ADD_TEAM = 'ADD_TEAM'
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM'
export const RECEIVE_EXERCISE = 'RECEIVE_EXERCISE'
export const SET_ACTIVE_EXERCISE = 'SET_ACTIVE_EXERCISE'
export const UPDATE_EXERCISE_INDEX = 'UPDATE_EXERCISE_INDEX'
export const SET_TITLE = 'SET_TITLE'
export const SET_THEME = 'SET_THEME'
export const SET_BACK_ROUTE = 'SET_BACK_ROUTE'
export const ADD_SESSION = 'ADD_SESSION'
export const DELETE_SESSION = 'DELETE_SESSION'

// Survey
// export const SET_SURVEY_QUESTIONS = 'SET_SURVEY_QUESTIONS'
export const SET_SURVEY_PRE = 'SET_SURVEY_PRE'
export const SET_SURVEY_POST = 'SET_SURVEY_POST'
export const SET_SURVEY_SHARP_BRAINS = 'SET_SURVEY_SHARP_BRAINS'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js